import axios from '../utils/request.js'

export default {
 
  login(data) { 
    data = JSON.stringify(data)
    return axios.postjson('/app/H5PhoneGetLogin',data)
  },
  tokenlogin(data) { 
    data = JSON.stringify(data)
    return axios.postjson('/app/H5TokenGetLogin',data)
  },
  getcode(data) {
    data = JSON.stringify(data)
    return axios.postjson('/app/SendSmsCode', data)
  },
};